import { Validator } from '@portal/kit/pkg/services'

const unsubscribeValidator = values => {
  const rules = {
    resiliation_date: ['isRequired']
  }

  return new Validator(values, rules).getErrors()
}

export default unsubscribeValidator
